import getOcTheme from '../../../theme/services/getOcTheme';

import blockquotes from './blockquotes';
import codes from './codes';
import images from './images';
import keys from './keys';
import maths from './maths';
import semanticBlocks from './semanticBlocks';
import tables from './tables';
import typographies from './typographies';
import videos from './videos';
import codesandbox from './codesandbox';
import expandableContent from './expandableContent';
import lockedContent from './lockedContent';

const theme = getOcTheme();

const { spacing, palette } = theme;

export default {
  root: {
    color: palette.text.onMain,
    '& > *:not(.oc-video)': {
      marginLeft: spacing(2),
      marginRight: spacing(2),
    },
    ...blockquotes,
    ...codes,
    ...images,
    ...keys,
    ...maths,
    ...semanticBlocks,
    ...tables,
    ...typographies,
    ...videos,
    ...codesandbox,
    ...expandableContent,
    ...lockedContent,
  },
};
